import type { GanttLocalObrasProps } from "./types-gantt-local-obras";
import { useGanttLocalObras } from "./use-gantt-local-obras";
import { GanttLocalObrasView } from "./view-gantt-local-obras";

export function GanttLocalObras(props: GanttLocalObrasProps) {
  const vm = useGanttLocalObras(props);

  return <GanttLocalObrasView {...vm} />;
}

export type * from "./types-gantt-local-obras";
